module.exports = __webpack_public_path__ + "img/EMT-LUCA_10X_LU.5695ad6b.png";